var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    color: "currentColor",
    d: "M31.837 31.14l-4.518-4.55a9.272 9.272 0 002.386-6.235c0-5.155-4.199-9.355-9.352-9.355A9.348 9.348 0 0011 20.355c0 5.186 4.2 9.386 9.353 9.386 2.417 0 4.58-.923 6.235-2.418l4.517 4.518a.51.51 0 00.35.159.51.51 0 00.35-.16c.254-.19.254-.508.032-.7zm-11.484-2.48c-4.581 0-8.335-3.755-8.335-8.337s3.754-8.305 8.335-8.305c4.612 0 8.334 3.755 8.334 8.337 0 4.581-3.753 8.304-8.334 8.304z"
  })));
}
export default SvgSearchIcon;